/**
 * @author wangyingxu1
 * 工具方法类
 */

import { urlMap } from '@/config';

const setStorage = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

const getStorage = (key: string): any => {
  const jsonStr: string | null = localStorage.getItem(key);
  let data;
  if (jsonStr) {
    try {
      data = JSON.parse(jsonStr);
    } catch (e) {
      data = undefined;
    }
  }
  return data;
};

const removeStorage = (key: string): void => {
  localStorage.removeItem(key);
};

const setCookie = (
  name: string,
  value: string,
  domain: string,
  days: number = 1
): void => {
  const exp = new Date();
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
  const params = `${name}=${escape(value)};`;
  const path = 'path=/;';
  const domainStr = domain ? `domain=${domain};` : '';
  const expires = `expires=${exp.toUTCString()}`;
  document.cookie = `${params}${path}${domainStr}${expires}`;
};

const getCookie = (name: string): any => {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  try {
    const arr: any = document.cookie.match(reg);
    return unescape(arr[2]);
  } catch {
    return undefined;
  }
};

const delCookie = (name: string): void => {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = getCookie(name);
  if (cval !== null) {
    document.cookie = `${name}=${cval};expires=${exp.toUTCString()}`;
  }
};

const clearCookie = (): void => {
  const keys: string[] = document.cookie.match(/[^ =;]+(?=\=)/g) || [];
  keys.forEach((item: string): void => {
    delCookie(item);
  });
};

const logout = (): void => {
  clearCookie();
  window.localStorage.clear();
  window.location.href = urlMap.logout;
};

export{
  setStorage,
  getStorage,
  removeStorage,
  setCookie,
  getCookie,
  delCookie,
  clearCookie,

  logout
};
